import { Button } from "@/components/ui/button";
import { appRoutes, RouteNames } from "@/shared/constants/routes";
import { useTranslation } from "@/shared/i18n";
import { Link } from "react-router-dom";
import { SEO } from "./SEO";
import { Section } from "./Section";
import { SectionHeading } from "./SectionHeading";

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <>
      <SEO title={t("errors.notFoundTitle")} noIndex />
      <Section tone="cream-light" size="lg">
        <SectionHeading
          as="h1"
          eyebrow="404"
          title={t("errors.notFoundTitle")}
          lead={t("errors.notFoundBody")}
          action={
            <Button asChild>
              <Link to={appRoutes[RouteNames.landing].path}>
                {t("errors.goHome")}
              </Link>
            </Button>
          }
        />
      </Section>
    </>
  );
};

export { NotFound };
